import React from "react";
import Icon, { CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

import TimeStop from "../Elements/TimeStop";
import { STATUS } from "../../constants";
import { getTranslation } from "../../utils/helper";
import { selectAllLabels } from "../../modules/label/stores/slice";

const StepPopup = ({
  route,
  stop,
  step,
  stepPopover,
  setStepsHovered,
  onClickStep,
  moveToUnscheduled,
  indexSteps,
  setting,
}) => {
  const { user } = useSelector(state => state.auth);
  const allLabels = useSelector(selectAllLabels);

  const canEdit = !user?.roles?.includes("user");
  const status = STATUS.find(s => s.code === stop.status);
  return (
    <div className="step-popup">
      <a className="btn-close" onClick={() => setStepsHovered({ [stepPopover]: false })}>
        <CloseOutlined />
      </a>
      <div className="header">
        <div className="left">{stop.orderRef || stop.orderCode}</div>
        <TimeStop stop={stop} />
      </div>
      <p>
        <strong>
          [
          {step.type.toLowerCase() === "pickup"
            ? getTranslation(setting, "Orders", "Pickup")
            : getTranslation(setting, "Orders", "Delivery")}
          ] [{getTranslation(setting, "Orders", status?.name ?? "N/A")}] {stop.name}
        </strong>
      </p>
      <p>{stop.address}</p>
      {stop.labels?.length > 0 && (
        <div className="labels">
          {stop.labels.map(l => {
            const label = allLabels.find(l2 => l2._id === l);
            return (
              <div
                className="label"
                key={l}
                style={{
                  backgroundColor: `#${label?.color}`,
                  width: "8px",
                  height: "8px",
                }}
              />
            );
          })}
        </div>
      )}
      <div className="actions">
        {canEdit && !["failed", "skipped", "completed"].includes(stop && stop.status) && (
          <a onClick={() => moveToUnscheduled(route, indexSteps)}>
            {getTranslation(setting, "Common", "Move to Unscheduled")}
            <Icon
              component={MoveToInbox}
              style={{
                width: 14,
                marginLeft: 5,
              }}
            />
          </a>
        )}
        {step.routePlanType === "PDP" && (
          <a
            onClick={() => onClickStep(step.orderId, step.type.toLowerCase() === "pickup" ? "delivery" : "pickup")}
            style={{
              marginLeft: 20,
            }}>
            {getTranslation(setting, "Common", "Go to")}{" "}
            {step.type.toLowerCase() === "pickup"
              ? getTranslation(setting, "Orders", "Delivery")
              : getTranslation(setting, "Orders", "Pickup")}
            <Icon
              component={ArrowRight}
              style={{
                width: 10,
                marginLeft: 5,
              }}
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default StepPopup;

const MoveToInbox = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z" />
  </svg>
);

const ArrowRight = () => (
  <svg viewBox="0 0 448 512">
    <path
      fill="currentColor"
      d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"
      className=""></path>
  </svg>
);
